import { combineReducers } from 'redux';

import { loadingReducer } from './loading';
import { toastReducer } from './toast';
import { userReducer } from './user';

const glueReducers = combineReducers({
  loading: loadingReducer,
  toast: toastReducer,
  user: userReducer,
});

export default glueReducers;
